function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1086_49)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165 0H0V165H165V0Z",
  fill: "#DDE9AF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.9952 -0.000976562L93.8721 0.0986318L93.8526 0.114257C91.4847 11.0352 88.5347 21.8211 85.9875 32.7C82.6648 45.2729 78.3318 57.7649 77.7863 70.8818C76.5302 79.5444 77.2014 88.4026 79.4894 96.8446C80.2928 100.673 81.9204 104.378 82.4367 108.218C81.5405 123.353 79.1471 138.368 78.8019 153.547C78.6416 157.338 78.5082 161.129 78.3644 164.92C78.4629 164.953 78.5683 164.97 78.6691 164.998H164.811C164.893 164.705 164.956 164.403 164.999 164.094V0.165076C164.784 0.0975817 164.562 0.0454371 164.337 0.00101742H93.9954L93.9952 -0.000976562Z",
  fill: "#F3CB6B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.3194 2.44043C92.5134 6.0331 91.6622 9.61518 90.7803 13.1904H164.999V2.44043H93.3193H93.3194Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.3086 19.1895C88.4131 22.7694 87.5274 26.3516 86.666 29.9394H164.999V19.1895H89.309H89.3086Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.2295 35.4395C84.2483 39.0192 83.2346 42.5982 82.2568 46.1894H164.998V35.4395H85.2288H85.2295Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.915 51.3145C80.0296 54.8707 79.2697 58.4504 78.7041 62.0644H164.999V51.3145H80.9151H80.915Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.0303 67.6895C77.938 68.7514 77.8306 69.8108 77.7861 70.8808C77.4224 73.3891 77.2385 75.9131 77.1904 78.4394H164.999V67.6895H78.0304H78.0303Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.3741 84.6279C77.6597 88.249 78.2555 91.8449 79.13 95.3779H164.998V84.6279H77.374H77.3741Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.5605 9.16016V12.9249H95.4095V9.16016H94.5605Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.9159 11.3931H96.1081C96.1081 8.93948 95.578 2.62412 94.9507 2.68006C94.3582 2.7637 93.7236 8.93937 93.7236 11.3931H94.9159Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.265 9.16016V12.9249H101.114V9.16016H100.265Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.616 11.3931H101.808C101.808 8.93948 101.278 2.62412 100.651 2.68006C100.058 2.7637 99.4238 8.93937 99.4238 11.3931H100.616Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.77 9.16016V12.9249H105.618V9.16016H104.77Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.125 11.3931H106.317C106.317 8.93948 105.787 2.62412 105.16 2.68006C104.567 2.7637 103.933 8.93937 103.933 11.3931H105.125Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.021 9.16016V12.9249H109.87V9.16016H109.021Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.377 11.3931H110.569C110.569 8.93948 110.039 2.62412 109.412 2.68006C108.819 2.7637 108.185 8.93937 108.185 11.3931H109.377Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.456 9.16016V12.9249H115.305V9.16016H114.456Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.811 11.3931H116.004C116.004 8.93948 115.474 2.62412 114.846 2.68006C114.254 2.7637 113.619 8.93937 113.619 11.3931H114.811Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.331 9.16016V12.9249H122.18V9.16016H121.331Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.686 11.3931H122.879C122.879 8.93948 122.348 2.62412 121.721 2.68006C121.129 2.7637 120.494 8.93937 120.494 11.3931H121.686Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.583 9.16016V12.9249H126.432V9.16016H125.583Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.938 11.3931H127.131C127.131 8.93948 126.6 2.62412 125.973 2.68006C125.381 2.7637 124.746 8.93937 124.746 11.3931H125.938Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.2021 25.9102V29.6749H93.0511V25.9102H92.2021Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.5536 28.1431H93.7458C93.7458 25.6895 93.2157 19.3741 92.5884 19.4301C91.9959 19.5137 91.3613 25.6894 91.3613 28.1431H92.5536Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.3896 25.9102V29.6749H99.2386V25.9102H98.3896Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.741 28.1431H99.9333C99.9333 25.6895 99.4032 19.3741 98.7759 19.4301C98.1834 19.5137 97.5488 25.6894 97.5488 28.1431H98.741Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.089 25.9102V29.6749H104.938V25.9102H104.089Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.444 28.1431H105.636C105.636 25.6895 105.106 19.3741 104.479 19.4301C103.887 19.5137 103.252 25.6894 103.252 28.1431H104.444Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.598 25.9102V29.6749H109.447V25.9102H108.598Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.95 28.1431H110.142C110.142 25.6895 109.612 19.3741 108.985 19.4301C108.392 19.5137 107.758 25.6894 107.758 28.1431H108.95Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.847 25.9102V29.6749H113.696V25.9102H112.847Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.202 28.1431H114.394C114.394 25.6895 113.864 19.3741 113.237 19.4301C112.644 19.5137 112.01 25.6894 112.01 28.1431H113.202Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.285 25.9102V29.6749H119.134V25.9102H118.285Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.64 28.1431H119.833C119.833 25.6895 119.303 19.3741 118.675 19.4301C118.083 19.5137 117.448 25.6894 117.448 28.1431H118.64Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.16 25.9102V29.6749H126.009V25.9102H125.16Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.515 28.1431H126.708C126.708 25.6895 126.178 19.3741 125.55 19.4301C124.958 19.5137 124.323 25.6894 124.323 28.1431H125.515Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.408 25.9102V29.6749H130.257V25.9102H129.408Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.764 28.1431H130.956C130.956 25.6895 130.426 19.3741 129.798 19.4301C129.206 19.5137 128.571 25.6894 128.571 28.1431H129.764Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.4336 42.085V45.8497H91.2825V42.085H90.4336Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.7889 44.3188H91.9811C91.9811 41.8653 91.451 35.5499 90.8237 35.6058C90.2313 35.6895 89.5967 41.8651 89.5967 44.3188H90.7889Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3848 42.085V45.8497H96.2337V42.085H95.3848Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.7362 44.3188H96.9284C96.9284 41.8653 96.3983 35.5499 95.771 35.6058C95.1785 35.6895 94.5439 41.8651 94.5439 44.3188H95.7362Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.572 42.085V45.8497H102.421V42.085H101.572Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.924 44.3188H103.116C103.116 41.8653 102.586 35.5499 101.959 35.6058C101.366 35.6895 100.731 41.8651 100.731 44.3188H101.924Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.271 42.085V45.8497H108.12V42.085H107.271Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.627 44.3188H108.819C108.819 41.8653 108.289 35.5499 107.662 35.6058C107.069 35.6895 106.435 41.8651 106.435 44.3188H107.627Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.78 42.085V45.8497H112.629V42.085H111.78Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.132 44.3188H113.324C113.324 41.8653 112.794 35.5499 112.167 35.6058C111.574 35.6895 110.939 41.8651 110.939 44.3188H112.132Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.028 42.085V45.8497H116.877V42.085H116.028Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.384 44.3188H117.576C117.576 41.8653 117.046 35.5499 116.418 35.6058C115.826 35.6895 115.191 41.8651 115.191 44.3188H116.384Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.468 42.085V45.8497H122.317V42.085H121.468Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.823 44.3188H123.015C123.015 41.8653 122.485 35.5499 121.858 35.6058C121.265 35.6895 120.631 41.8651 120.631 44.3188H121.823Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.343 42.085V45.8497H129.192V42.085H128.343Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.698 44.3188H129.89C129.89 41.8653 129.36 35.5499 128.733 35.6058C128.14 35.6895 127.506 41.8651 127.506 44.3188H128.698Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1113 57.9062V61.671H92.9603V57.9062H92.1113Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.4666 60.1401H93.6589C93.6589 57.6866 93.1288 51.3712 92.5015 51.4271C91.909 51.5108 91.2744 57.6864 91.2744 60.1401H92.4666Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0625 57.9062V61.671H97.9114V57.9062H97.0625Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4178 60.1401H98.61C98.61 57.6866 98.0799 51.3712 97.4527 51.4271C96.8602 51.5108 96.2256 57.6864 96.2256 60.1401H97.4178Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.25 57.9062V61.671H104.099V57.9062H103.25Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.605 60.1401H104.798C104.798 57.6866 104.267 51.3712 103.64 51.4271C103.048 51.5108 102.413 57.6864 102.413 60.1401H103.605Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.949 57.9062V61.671H109.798V57.9062H108.949Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.305 60.1401H110.497C110.497 57.6866 109.967 51.3712 109.339 51.4271C108.747 51.5108 108.112 57.6864 108.112 60.1401H109.305Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.459 57.9062V61.671H114.308V57.9062H113.459Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.814 60.1401H115.007C115.007 57.6866 114.476 51.3712 113.849 51.4271C113.257 51.5108 112.622 57.6864 112.622 60.1401H113.814Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.707 57.9062V61.671H118.556V57.9062H117.707Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.062 60.1401H119.255C119.255 57.6866 118.724 51.3712 118.097 51.4271C117.505 51.5108 116.87 57.6864 116.87 60.1401H118.062Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.146 57.9062V61.671H123.994V57.9062H123.146Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.501 60.1401H124.693C124.693 57.6866 124.163 51.3712 123.536 51.4271C122.943 51.5108 122.309 57.6864 122.309 60.1401H123.501Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.962 57.9062V61.671H129.811V57.9062H128.962Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.314 60.1401H130.507C130.507 57.6866 129.976 51.3712 129.349 51.4271C128.757 51.5108 128.122 57.6864 128.122 60.1401H129.314Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.3184 74.2832V78.048H92.1673V74.2832H91.3184Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.6698 76.5132H92.862C92.862 74.0596 92.3319 67.7442 91.7046 67.8002C91.1121 67.8838 90.4775 74.0595 90.4775 76.5132H91.6698Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.2656 74.2832V78.048H97.1146V74.2832H96.2656Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.6209 76.5132H97.8132C97.8132 74.0596 97.2831 67.7442 96.6558 67.8002C96.0633 67.8838 95.4287 74.0595 95.4287 76.5132H96.6209Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.452 74.2832V78.048H103.301V74.2832H102.452Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.807 76.5132H104C104 74.0596 103.47 67.7442 102.842 67.8002C102.25 67.8838 101.615 74.0595 101.615 76.5132H102.807Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.156 74.2832V78.048H109.005V74.2832H108.156Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.512 76.5132H109.704C109.704 74.0596 109.174 67.7442 108.546 67.8002C107.954 67.8838 107.319 74.0595 107.319 76.5132H108.512Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.665 74.2832V78.048H113.514V74.2832H112.665Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.016 76.5132H114.209C114.209 74.0596 113.679 67.7442 113.051 67.8002C112.459 67.8838 111.824 74.0595 111.824 76.5132H113.016Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.913 74.2832V78.048H117.762V74.2832H116.913Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.268 76.5132H118.461C118.461 74.0596 117.931 67.7442 117.303 67.8002C116.711 67.8838 116.076 74.0595 116.076 76.5132H117.268Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.352 74.2832V78.048H123.2V74.2832H122.352Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.703 76.5132H123.895C123.895 74.0596 123.365 67.7442 122.738 67.8002C122.145 67.8838 121.511 74.0595 121.511 76.5132H122.703Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.165 74.2832V78.048H129.014V74.2832H128.165Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.52 76.5132H129.713C129.713 74.0596 129.182 67.7442 128.555 67.8002C127.963 67.8838 127.328 74.0595 127.328 76.5132H128.52Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.146 9.16016V12.9249H130.994V9.16016H130.146Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.501 11.3931H131.693C131.693 8.93948 131.163 2.62412 130.536 2.68006C129.943 2.7637 129.309 8.93937 129.309 11.3931H130.501Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.834 9.16016V12.9249H136.683V9.16016H135.834Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.189 11.3931H137.382C137.382 8.93948 136.851 2.62412 136.224 2.68006C135.632 2.7637 134.997 8.93937 134.997 11.3931H136.189Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.083 9.16016V12.9249H143.932V9.16016H143.083Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.438 11.3931H144.631C144.631 8.93948 144.1 2.62412 143.473 2.68006C142.881 2.7637 142.246 8.93937 142.246 11.3931H143.438Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.21 9.16016V12.9249H148.059V9.16016H147.21Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.561 11.3931H148.754C148.754 8.93948 148.224 2.62412 147.596 2.68006C147.004 2.7637 146.369 8.93937 146.369 11.3931H147.561Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.333 9.16016V12.9249H152.182V9.16016H151.333Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.688 11.3931H152.881C152.881 8.93948 152.35 2.62412 151.723 2.68006C151.131 2.7637 150.496 8.93937 150.496 11.3931H151.688Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.833 9.16016V12.9249H157.682V9.16016H156.833Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.188 11.3931H158.381C158.381 8.93948 157.85 2.62412 157.223 2.68006C156.631 2.7637 155.996 8.93937 155.996 11.3931H157.188Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.022 9.16016V12.9249H162.871V9.16016H162.022Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.374 11.3931H163.566C163.566 8.93948 163.036 2.62412 162.409 2.68006C161.816 2.7637 161.182 8.93937 161.182 11.3931H162.374Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.295 25.9102V29.6749H135.144V25.9102H134.295Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.646 28.1431H135.839C135.839 25.6895 135.308 19.3741 134.681 19.4301C134.089 19.5137 133.454 25.6894 133.454 28.1431H134.646Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.108 25.9102V29.6749H140.957V25.9102H140.108Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.46 28.1431H141.652C141.652 25.6895 141.122 19.3741 140.495 19.4301C139.902 19.5137 139.268 25.6894 139.268 28.1431H140.46Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.605 25.9102V29.6749H147.454V25.9102H146.605Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.961 28.1431H148.153C148.153 25.6895 147.623 19.3741 146.996 19.4301C146.403 19.5137 145.769 25.6894 145.769 28.1431H146.961Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.294 25.9102V29.6749H153.143V25.9102H152.294Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.649 28.1431H153.841C153.841 25.6895 153.311 19.3741 152.684 19.4301C152.092 19.5137 151.457 25.6894 151.457 28.1431H152.649Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.546 25.9102V29.6749H162.395V25.9102H161.546Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.897 28.1431H163.09C163.09 25.6895 162.559 19.3741 161.932 19.4301C161.34 19.5137 160.705 25.6894 160.705 28.1431H161.897Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.92 25.9102V29.6749H157.769V25.9102H156.92Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.275 28.1431H158.467C158.467 25.6895 157.937 19.3741 157.31 19.4301C156.718 19.5137 156.083 25.6894 156.083 28.1431H157.275Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.029 42.085V45.8497H133.878V42.085H133.029Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.385 44.3188H134.577C134.577 41.8653 134.047 35.5499 133.419 35.6058C132.827 35.6895 132.192 41.8651 132.192 44.3188H133.385Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.967 42.085V45.8497H139.816V42.085H138.967Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.322 44.3188H140.514C140.514 41.8653 139.984 35.5499 139.357 35.6058C138.764 35.6895 138.13 41.8651 138.13 44.3188H139.322Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.154 42.085V45.8497H146.003V42.085H145.154Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.51 44.3188H146.702C146.702 41.8653 146.172 35.5499 145.544 35.6058C144.952 35.6895 144.317 41.8651 144.317 44.3188H145.51Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.603 42.085V45.8497H150.451V42.085H149.603Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.954 44.3188H151.146C151.146 41.8653 150.616 35.5499 149.989 35.6058C149.396 35.6895 148.762 41.8651 148.762 44.3188H149.954Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.728 42.085V45.8497H155.576V42.085H154.728Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.079 44.3188H156.271C156.271 41.8653 155.741 35.5499 155.114 35.6058C154.521 35.6895 153.887 41.8651 153.887 44.3188H155.079Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.603 42.085V45.8497H162.451V42.085H161.603Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.954 44.3188H163.146C163.146 41.8653 162.616 35.5499 161.989 35.6058C161.396 35.6895 160.762 41.8651 160.762 44.3188H161.954Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.094 57.9062V61.671H133.943V57.9062H133.094Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.449 60.1401H134.641C134.641 57.6866 134.111 51.3712 133.484 51.4271C132.891 51.5108 132.257 57.6864 132.257 60.1401H133.449Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.157 57.9062V61.671H141.006V57.9062H140.157Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.513 60.1401H141.705C141.705 57.6866 141.175 51.3712 140.547 51.4271C139.955 51.5108 139.32 57.6864 139.32 60.1401H140.513Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.909 57.9062V61.671H148.758V57.9062H147.909Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.261 60.1401H149.453C149.453 57.6866 148.923 51.3712 148.295 51.4271C147.703 51.5108 147.068 57.6864 147.068 60.1401H148.261Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.847 57.9062V61.671H144.696V57.9062H143.847Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.198 60.1401H145.39C145.39 57.6866 144.86 51.3712 144.233 51.4271C143.64 51.5108 143.006 57.6864 143.006 60.1401H144.198Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.034 57.9062V61.671H153.883V57.9062H153.034Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.386 60.1401H154.578C154.578 57.6866 154.048 51.3712 153.42 51.4271C152.828 51.5108 152.193 57.6864 152.193 60.1401H153.386Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.282 57.9062V61.671H160.131V57.9062H159.282Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.638 60.1401H160.83C160.83 57.6866 160.3 51.3712 159.672 51.4271C159.08 51.5108 158.445 57.6864 158.445 60.1401H159.638Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.096 57.9062V61.671H163.945V57.9062H163.096Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.451 60.1401H164.643C164.643 57.6866 164.113 51.3712 163.486 51.4271C162.893 51.5108 162.259 57.6864 162.259 60.1401H163.451Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.863 74.2832V78.048H133.712V74.2832H132.863Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.215 76.5132H134.407C134.407 74.0596 133.877 67.7442 133.25 67.8002C132.657 67.8838 132.022 74.0595 132.022 76.5132H133.215Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.551 74.2832V78.048H139.4V74.2832H138.551Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.902 76.5132H140.094C140.094 74.0596 139.564 67.7442 138.937 67.8002C138.345 67.8838 137.71 74.0595 137.71 76.5132H138.902Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.423 74.2832V78.048H144.272V74.2832H143.423Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.778 76.5132H144.97C144.97 74.0596 144.44 67.7442 143.813 67.8002C143.221 67.8838 142.586 74.0595 142.586 76.5132H143.778Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.361 74.2832V78.048H148.21V74.2832H147.361Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.717 76.5132H148.909C148.909 74.0596 148.379 67.7442 147.751 67.8002C147.159 67.8838 146.524 74.0595 146.524 76.5132H147.717Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.05 74.2832V78.048H151.899V74.2832H151.05Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.405 76.5132H152.597C152.597 74.0596 152.067 67.7442 151.44 67.8002C150.847 67.8838 150.213 74.0595 150.213 76.5132H151.405Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.676 74.2832V78.048H156.525V74.2832H155.676Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.028 76.5132H157.22C157.22 74.0596 156.69 67.7442 156.063 67.8002C155.471 67.8838 154.836 74.0595 154.836 76.5132H156.028Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.425 74.2832V78.048H162.274V74.2832H161.425Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.78 76.5132H162.972C162.972 74.0596 162.442 67.7442 161.815 67.8002C161.222 67.8838 160.588 74.0595 160.588 76.5132H161.78Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.7246 101.378C81.418 103.646 82.127 105.909 82.4375 108.218C82.3603 109.522 82.2593 110.825 82.1621 112.128H165V101.378H80.7251H80.7246Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.708 117.628C81.3839 121.214 81.0237 124.795 80.6611 128.378H164.999V117.628H81.7081H81.708Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.1758 133.498C79.8287 137.078 79.5013 140.66 79.2559 144.248H164.999V133.498H80.1759H80.1758Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9424 149.878C78.8897 151.101 78.8296 152.323 78.8018 153.548C78.702 155.907 78.6182 158.268 78.5303 160.628H164.999V149.878H78.9423H78.9424Z",
  fill: "#FFDA6F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4814 42.085V45.8497H86.3304V42.085H85.4814Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.8368 44.3188H87.029C87.029 41.8653 86.4989 35.5499 85.8716 35.6058C85.2791 35.6895 84.6445 41.8651 84.6445 44.3188H85.8368Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.6758 57.9062V61.671H87.5247V57.9062H86.6758Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.0311 60.1401H88.2233C88.2233 57.6866 87.6932 51.3712 87.0659 51.4271C86.4735 51.5108 85.8389 57.6864 85.8389 60.1401H87.0311Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.6709 74.2832V78.048H84.5198V74.2832H83.6709Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.0233 76.5132H85.2155C85.2155 74.0596 84.6854 67.7442 84.0581 67.8002C83.4656 67.8838 82.8311 74.0595 82.8311 76.5132H84.0233Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.1758 91.5176V95.2823H86.0247V91.5176H85.1758Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.5272 93.7476H86.7194C86.7194 91.294 86.1893 84.9786 85.562 85.0345C84.9695 85.1182 84.335 91.2939 84.335 93.7476H85.5272Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.0527 91.5176V95.2823H91.9017V91.5176H91.0527Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4041 93.7476H92.5964C92.5964 91.294 92.0663 84.9786 91.439 85.0345C90.8465 85.1182 90.2119 91.2939 90.2119 93.7476H91.4041Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.8389 91.5176V95.2823H97.6878V91.5176H96.8389Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.1912 93.7476H98.3835C98.3835 91.294 97.8534 84.9786 97.2261 85.0345C96.6336 85.1182 95.999 91.2939 95.999 93.7476H97.1912Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.134 91.5176V95.2823H104.983V91.5176H104.134Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.485 93.7476H105.677C105.677 91.294 105.147 84.9786 104.52 85.0345C103.928 85.1182 103.293 91.2939 103.293 93.7476H104.485Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.292 91.5176V95.2823H112.141V91.5176H111.292Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.643 93.7476H112.836C112.836 91.294 112.306 84.9786 111.678 85.0345C111.086 85.1182 110.451 91.2939 110.451 93.7476H111.643Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.491 91.5176V95.2823H116.34V91.5176H115.491Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.843 93.7476H117.035C117.035 91.294 116.505 84.9786 115.877 85.0345C115.285 85.1182 114.65 91.2939 114.65 93.7476H115.843Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.897 91.5176V95.2823H122.746V91.5176H121.897Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.249 93.7476H123.441C123.441 91.294 122.911 84.9786 122.284 85.0345C121.691 85.1182 121.057 91.2939 121.057 93.7476H122.249Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.251 91.5176V95.2823H131.1V91.5176H130.251Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.602 93.7476H131.795C131.795 91.294 131.265 84.9786 130.637 85.0345C130.045 85.1182 129.41 91.2939 129.41 93.7476H130.602Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.821 91.5176V95.2823H136.67V91.5176H135.821Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.173 93.7476H137.365C137.365 91.294 136.835 84.9786 136.208 85.0345C135.615 85.1182 134.98 91.2939 134.98 93.7476H136.173Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.211 91.5176V95.2823H142.06V91.5176H141.211Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.562 93.7476H142.755C142.755 91.294 142.224 84.9786 141.597 85.0345C141.005 85.1182 140.37 91.2939 140.37 93.7476H141.562Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.105 91.5176V95.2823H148.954V91.5176H148.105Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.457 93.7476H149.649C149.649 91.294 149.119 84.9786 148.492 85.0345C147.899 85.1182 147.265 91.2939 147.265 93.7476H148.457Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.598 91.5176V95.2823H152.447V91.5176H151.598Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.949 93.7476H153.141C153.141 91.294 152.611 84.9786 151.984 85.0345C151.391 85.1182 150.757 91.2939 150.757 93.7476H151.949Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.606 91.5176V95.2823H158.455V91.5176H157.606Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.959 93.7476H159.151C159.151 91.294 158.621 84.9786 157.994 85.0345C157.401 85.1182 156.767 91.2939 156.767 93.7476H157.959Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.822 91.5176V95.2823H163.671V91.5176H162.822Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.175 93.7476H164.367C164.367 91.294 163.837 84.9786 163.209 85.0345C162.617 85.1182 161.982 91.2939 161.982 93.7476H163.175Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.2021 108.155V111.92H93.0511V108.155H92.2021Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.5536 110.389H93.7458C93.7458 107.936 93.2157 101.62 92.5884 101.676C91.9959 101.76 91.3613 107.935 91.3613 110.389H92.5536Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.3887 108.155V111.92H99.2376V108.155H98.3887Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.7401 110.389H99.9323C99.9323 107.936 99.4022 101.62 98.7749 101.676C98.1824 101.76 97.5479 107.935 97.5479 110.389H98.7401Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.089 108.155V111.92H104.938V108.155H104.089Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.444 110.389H105.636C105.636 107.936 105.106 101.62 104.479 101.676C103.887 101.76 103.252 107.935 103.252 110.389H104.444Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.598 108.155V111.92H109.447V108.155H108.598Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.949 110.389H110.141C110.141 107.936 109.611 101.62 108.984 101.676C108.391 101.76 107.757 107.935 107.757 110.389H108.949Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.846 108.155V111.92H113.695V108.155H112.846Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.201 110.389H114.393C114.393 107.936 113.863 101.62 113.236 101.676C112.643 101.76 112.009 107.935 112.009 110.389H113.201Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.284 108.155V111.92H119.133V108.155H118.284Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.639 110.389H119.832C119.832 107.936 119.302 101.62 118.674 101.676C118.082 101.76 117.447 107.935 117.447 110.389H118.639Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.159 108.155V111.92H126.008V108.155H125.159Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.514 110.389H126.707C126.707 107.936 126.177 101.62 125.549 101.676C124.957 101.76 124.322 107.935 124.322 110.389H125.514Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.407 108.155V111.92H130.256V108.155H129.407Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.763 110.389H130.955C130.955 107.936 130.425 101.62 129.797 101.676C129.205 101.76 128.57 107.935 128.57 110.389H129.763Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.4326 124.332V128.097H91.2815V124.332H90.4326Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.7879 126.566H91.9801C91.9801 124.112 91.4501 117.797 90.8228 117.853C90.2303 117.937 89.5957 124.112 89.5957 126.566H90.7879Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3838 124.332V128.097H96.2327V124.332H95.3838Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.7362 126.566H96.9284C96.9284 124.112 96.3983 117.797 95.771 117.853C95.1785 117.937 94.5439 124.112 94.5439 126.566H95.7362Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.571 124.332V128.097H102.42V124.332H101.571Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.923 126.566H103.115C103.115 124.112 102.585 117.797 101.958 117.853C101.365 117.937 100.73 124.112 100.73 126.566H101.923Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.271 124.332V128.097H108.119V124.332H107.271Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.626 126.566H108.818C108.818 124.112 108.288 117.797 107.661 117.853C107.068 117.937 106.434 124.112 106.434 126.566H107.626Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.78 124.332V128.097H112.629V124.332H111.78Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.132 126.566H113.324C113.324 124.112 112.794 117.797 112.167 117.853C111.574 117.937 110.939 124.112 110.939 126.566H112.132Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.028 124.332V128.097H116.877V124.332H116.028Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.384 126.566H117.576C117.576 124.112 117.046 117.797 116.418 117.853C115.826 117.937 115.191 124.112 115.191 126.566H116.384Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.467 124.332V128.097H122.316V124.332H121.467Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.822 126.566H123.014C123.014 124.112 122.484 117.797 121.857 117.853C121.264 117.937 120.63 124.112 120.63 126.566H121.822Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.342 124.332V128.097H129.191V124.332H128.342Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.697 126.566H129.889C129.889 124.112 129.359 117.797 128.732 117.853C128.139 117.937 127.505 124.112 127.505 126.566H128.697Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1113 140.153V143.918H92.9603V140.153H92.1113Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.4666 142.387H93.6589C93.6589 139.934 93.1288 133.618 92.5015 133.674C91.909 133.758 91.2744 139.934 91.2744 142.387H92.4666Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0625 140.153V143.918H97.9114V140.153H97.0625Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4178 142.387H98.61C98.61 139.934 98.0799 133.618 97.4527 133.674C96.8602 133.758 96.2256 139.934 96.2256 142.387H97.4178Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.249 140.153V143.918H104.098V140.153H103.249Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.604 142.387H104.797C104.797 139.934 104.266 133.618 103.639 133.674C103.047 133.758 102.412 139.934 102.412 142.387H103.604Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.949 140.153V143.918H109.798V140.153H108.949Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.305 142.387H110.497C110.497 139.934 109.967 133.618 109.339 133.674C108.747 133.758 108.112 139.934 108.112 142.387H109.305Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.458 140.153V143.918H114.307V140.153H113.458Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.813 142.387H115.006C115.006 139.934 114.475 133.618 113.848 133.674C113.256 133.758 112.621 139.934 112.621 142.387H113.813Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.706 140.153V143.918H118.555V140.153H117.706Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.061 142.387H119.254C119.254 139.934 118.723 133.618 118.096 133.674C117.504 133.758 116.869 139.934 116.869 142.387H118.061Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.145 140.153V143.918H123.993V140.153H123.145Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.5 142.387H124.692C124.692 139.934 124.162 133.618 123.535 133.674C122.942 133.758 122.308 139.934 122.308 142.387H123.5Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.962 140.153V143.918H129.811V140.153H128.962Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.313 142.387H130.506C130.506 139.934 129.975 133.618 129.348 133.674C128.756 133.758 128.121 139.934 128.121 142.387H129.313Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.3174 156.53V160.295H92.1663V156.53H91.3174Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.6688 158.76H92.861C92.861 156.307 92.3309 149.991 91.7036 150.047C91.1111 150.131 90.4766 156.307 90.4766 158.76H91.6688Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.2646 156.53V160.295H97.1136V156.53H96.2646Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.62 158.76H97.8122C97.8122 156.307 97.2821 149.991 96.6548 150.047C96.0623 150.131 95.4277 156.307 95.4277 158.76H96.62Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.452 156.53V160.295H103.301V156.53H102.452Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.807 158.76H104C104 156.307 103.47 149.991 102.842 150.047C102.25 150.131 101.615 156.307 101.615 158.76H102.807Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.155 156.53V160.295H109.004V156.53H108.155Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.511 158.76H109.703C109.703 156.307 109.173 149.991 108.545 150.047C107.953 150.131 107.318 156.307 107.318 158.76H108.511Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.664 156.53V160.295H113.513V156.53H112.664Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.015 158.76H114.208C114.208 156.307 113.678 149.991 113.05 150.047C112.458 150.131 111.823 156.307 111.823 158.76H113.015Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.912 156.53V160.295H117.761V156.53H116.912Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.267 158.76H118.46C118.46 156.307 117.93 149.991 117.302 150.047C116.71 150.131 116.075 156.307 116.075 158.76H117.267Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.352 156.53V160.295H123.2V156.53H122.352Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.703 158.76H123.895C123.895 156.307 123.365 149.991 122.738 150.047C122.145 150.131 121.511 156.307 121.511 158.76H122.703Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.164 156.53V160.295H129.013V156.53H128.164Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.519 158.76H129.712C129.712 156.307 129.182 149.991 128.554 150.047C127.962 150.131 127.327 156.307 127.327 158.76H128.519Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.295 108.155V111.92H135.144V108.155H134.295Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.646 110.389H135.839C135.839 107.936 135.308 101.62 134.681 101.676C134.089 101.76 133.454 107.935 133.454 110.389H134.646Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.107 108.155V111.92H140.956V108.155H140.107Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.459 110.389H141.651C141.651 107.936 141.121 101.62 140.494 101.676C139.901 101.76 139.267 107.935 139.267 110.389H140.459Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.604 108.155V111.92H147.453V108.155H146.604Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.96 110.389H148.152C148.152 107.936 147.622 101.62 146.995 101.676C146.402 101.76 145.768 107.935 145.768 110.389H146.96Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.293 108.155V111.92H153.142V108.155H152.293Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.648 110.389H153.841C153.841 107.936 153.31 101.62 152.683 101.676C152.091 101.76 151.456 107.935 151.456 110.389H152.648Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.545 108.155V111.92H162.394V108.155H161.545Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.896 110.389H163.089C163.089 107.936 162.558 101.62 161.931 101.676C161.339 101.76 160.704 107.935 160.704 110.389H161.896Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.919 108.155V111.92H157.768V108.155H156.919Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.274 110.389H158.466C158.466 107.936 157.936 101.62 157.309 101.676C156.717 101.76 156.082 107.935 156.082 110.389H157.274Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.028 124.332V128.097H133.877V124.332H133.028Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.384 126.566H134.576C134.576 124.112 134.046 117.797 133.418 117.853C132.826 117.937 132.191 124.112 132.191 126.566H133.384Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.966 124.332V128.097H139.815V124.332H138.966Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.321 126.566H140.513C140.513 124.112 139.983 117.797 139.356 117.853C138.763 117.937 138.129 124.112 138.129 126.566H139.321Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.153 124.332V128.097H146.002V124.332H145.153Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.509 126.566H146.701C146.701 124.112 146.171 117.797 145.543 117.853C144.951 117.937 144.316 124.112 144.316 126.566H145.509Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.602 124.332V128.097H150.45V124.332H149.602Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.953 126.566H151.145C151.145 124.112 150.615 117.797 149.988 117.853C149.395 117.937 148.761 124.112 148.761 126.566H149.953Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.727 124.332V128.097H155.575V124.332H154.727Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.078 126.566H156.27C156.27 124.112 155.74 117.797 155.113 117.853C154.52 117.937 153.886 124.112 153.886 126.566H155.078Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.602 124.332V128.097H162.45V124.332H161.602Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.953 126.566H163.145C163.145 124.112 162.615 117.797 161.988 117.853C161.395 117.937 160.761 124.112 160.761 126.566H161.953Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.093 140.153V143.918H133.942V140.153H133.093Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.448 142.387H134.64C134.64 139.934 134.11 133.618 133.483 133.674C132.89 133.758 132.256 139.934 132.256 142.387H133.448Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.156 140.153V143.918H141.005V140.153H140.156Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.512 142.387H141.704C141.704 139.934 141.174 133.618 140.546 133.674C139.954 133.758 139.319 139.934 139.319 142.387H140.512Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.908 140.153V143.918H148.757V140.153H147.908Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.26 142.387H149.452C149.452 139.934 148.922 133.618 148.294 133.674C147.702 133.758 147.067 139.934 147.067 142.387H148.26Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.846 140.153V143.918H144.695V140.153H143.846Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.197 142.387H145.389C145.389 139.934 144.859 133.618 144.232 133.674C143.639 133.758 143.005 139.934 143.005 142.387H144.197Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.033 140.153V143.918H153.882V140.153H153.033Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.386 142.387H154.578C154.578 139.934 154.048 133.618 153.42 133.674C152.828 133.758 152.193 139.934 152.193 142.387H153.386Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.281 140.153V143.918H160.13V140.153H159.281Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.637 142.387H160.829C160.829 139.934 160.299 133.618 159.671 133.674C159.079 133.758 158.444 139.934 158.444 142.387H159.637Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.095 140.153V143.918H163.944V140.153H163.095Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.45 142.387H164.642C164.642 139.934 164.112 133.618 163.485 133.674C162.892 133.758 162.258 139.934 162.258 142.387H163.45Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.862 156.53V160.295H133.711V156.53H132.862Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.214 158.76H134.406C134.406 156.307 133.876 149.991 133.249 150.047C132.656 150.131 132.021 156.307 132.021 158.76H133.214Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.551 156.53V160.295H139.4V156.53H138.551Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.902 158.76H140.094C140.094 156.307 139.564 149.991 138.937 150.047C138.345 150.131 137.71 156.307 137.71 158.76H138.902Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.422 156.53V160.295H144.271V156.53H143.422Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.777 158.76H144.969C144.969 156.307 144.439 149.991 143.812 150.047C143.22 150.131 142.585 156.307 142.585 158.76H143.777Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.36 156.53V160.295H148.209V156.53H147.36Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.716 158.76H148.908C148.908 156.307 148.378 149.991 147.751 150.047C147.158 150.131 146.523 156.307 146.523 158.76H147.716Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.05 156.53V160.295H151.899V156.53H151.05Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.405 158.76H152.597C152.597 156.307 152.067 149.991 151.44 150.047C150.847 150.131 150.213 156.307 150.213 158.76H151.405Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.676 156.53V160.295H156.525V156.53H155.676Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.027 158.76H157.219C157.219 156.307 156.689 149.991 156.062 150.047C155.47 150.131 154.835 156.307 154.835 158.76H156.027Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.424 156.53V160.295H162.273V156.53H161.424Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.779 158.76H162.971C162.971 156.307 162.441 149.991 161.814 150.047C161.222 150.131 160.587 156.307 160.587 158.76H161.779Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.8555 108.155V111.92H86.7044V108.155H85.8555Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.2078 110.389H87.4001C87.4001 107.936 86.87 101.62 86.2427 101.676C85.6502 101.76 85.0156 107.935 85.0156 110.389H86.2078Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.8379 124.332V128.097H84.6868V124.332H83.8379Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.1932 126.566H85.3854C85.3854 124.112 84.8553 117.797 84.228 117.853C83.6356 117.937 83.001 124.112 83.001 126.566H84.1932Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.7041 140.153V143.918H88.553V140.153H87.7041Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.0594 142.387H89.2516C89.2516 139.934 88.7215 133.618 88.0943 133.674C87.5018 133.758 86.8672 139.934 86.8672 142.387H88.0594Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.5488 140.153V143.918H83.3978V140.153H82.5488Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.9041 142.387H84.0964C84.0964 139.934 83.5663 133.618 82.939 133.674C82.3465 133.758 81.7119 139.934 81.7119 142.387H82.9041Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.4717 156.53V160.295H87.3206V156.53H86.4717Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.8231 158.76H88.0153C88.0153 156.307 87.4852 149.991 86.8579 150.047C86.2654 150.131 85.6309 156.307 85.6309 158.76H86.8231Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.0371 156.53V160.295H81.886V156.53H81.0371Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.3885 158.76H82.5807C82.5807 156.307 82.0507 149.991 81.4234 150.047C80.8309 150.131 80.1963 156.307 80.1963 158.76H81.3885Z",
  fill: "#AA8800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.0393 24.5949C26.0115 30.5417 38.6012 32.4107 32.5965 25.7188C31.8124 24.7106 30.3244 23.7697 29.0393 24.5949V24.5949Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5493 34.6854C41.0159 28.1755 28.3543 29.4711 35.8248 34.4742C36.8335 35.2577 38.5076 35.8023 39.5493 34.6854V34.6854Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.0925 29.4368C44.6129 25.6874 34.4849 17.9787 36.5183 26.7369C36.719 27.9982 37.5688 29.54 39.0925 29.4368V29.4368Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9501 137.012C23.3559 135.987 25.5016 148.533 29.9902 140.742C30.704 139.683 31.1345 137.976 29.9501 137.012Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8694 127.953C18.5534 132.706 24.3078 121.353 16.0605 124.933C14.8561 125.359 13.4929 126.473 13.8694 127.953Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.448 14.0532C79.9741 15.4458 78.5345 2.79958 73.6168 10.3266C72.8448 11.344 72.3194 13.0243 73.448 14.0532Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0518 81.6118C49.3932 87.8609 59.2733 79.8371 50.2827 79.747C49.0096 79.6445 47.3109 80.1067 47.0518 81.6118Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.7436 133.047C26.8181 127.049 17.7465 135.976 26.7047 135.211C27.9818 135.191 29.6288 134.57 29.7436 133.047Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.942 34.8037C40.8539 37.5363 49.4874 46.8884 49.0077 37.91C49.0293 36.633 48.4605 34.967 46.942 34.8037Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8924 37.7349C32.8421 43.114 40.1736 32.71 31.4961 35.0633C30.243 35.3102 28.7334 36.216 28.8924 37.7349Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.0043 35.1976C49.4859 33.6104 42.6851 22.852 41.5341 31.769C41.282 33.0211 41.5405 34.7625 43.0043 35.1976Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.3753 39.4282C40.051 44.9977 47.8934 34.9732 39.1092 36.89C37.8452 37.074 36.2923 37.9032 36.3753 39.4282Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9368 33.883C31.3039 27.3512 18.6635 28.8403 26.2095 33.7287C27.23 34.4967 28.9123 35.0156 29.9368 33.883Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0663 79.6693C50.0943 76.8064 41.2618 67.6423 41.9343 76.608C41.94 77.8852 42.5446 79.5387 44.0663 79.6693Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1276 82.0692C36.6718 85.9118 46.9288 93.4475 44.7473 84.725C44.5252 83.4673 43.6494 81.9401 42.1276 82.0692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.2958 80.6738C30.6332 81.0527 35.3587 92.8708 38.1162 84.3129C38.5924 83.1278 38.6559 81.3685 37.2958 80.6738Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6542 127.692C27.1474 121.191 16.3057 127.858 25.2077 129.12C26.4566 129.387 28.2011 129.151 28.6542 127.692Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.0612 77.4539C41.2019 70.7823 29.0521 74.5738 37.3693 77.9888C38.5138 78.5557 40.2628 78.7559 41.0612 77.4539Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0171 90.6669C19.5965 89.5523 13.591 78.3305 11.7985 87.1411C11.4566 88.3717 11.5884 90.1272 13.0171 90.6669Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6303 86.0865C14.6986 80.7966 2.66568 76.6482 7.33993 84.3287C7.92561 85.4637 9.21557 86.6618 10.6303 86.0865Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6718 140.455C17.3271 143.997 20.3027 131.622 13.1059 137.011C12.0323 137.703 10.9634 139.102 11.6718 140.455Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1028 129.578C5.71124 131.497 13.0566 141.891 13.7474 132.927C13.9348 131.663 13.5873 129.937 12.1028 129.578Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9569 134.272C21.2588 138.324 25.3717 126.28 17.7049 130.976C16.5716 131.565 15.3774 132.859 15.9569 134.272Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8269 135.682C15.5275 137.884 23.3309 147.939 23.6197 138.953C23.7504 137.682 23.3259 135.974 21.8269 135.682Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.3591 15.6106C68.7548 19.233 78.7037 27.1707 76.8711 18.3685C76.6992 17.1029 75.8848 15.5422 74.3591 15.6106Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.2153 13.6074C63.012 16.0675 71.2226 25.7931 71.1413 16.8023C71.2195 15.5275 70.7251 13.8378 69.2153 13.6074Z",
  fill: "#ECECEC",
  stroke: "black",
  strokeWidth: 0.499997,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.4659 -0.000976562C91.5116 10.188 88.2157 20.1769 86.2648 30.4208C82.781 44.1297 77.3028 57.5006 77.5169 71.9735C74.9497 84.0974 78.6473 96.0174 82.0051 107.391C81.8737 118.923 79.6317 130.36 78.9485 141.924C78.4275 149.65 78.4341 157.338 77.972 164.998H78.47C78.9336 157.326 78.9311 149.649 79.4505 141.953C80.1314 130.429 82.3768 118.983 82.5071 107.385V107.348L82.4915 107.311C79.1231 95.8991 75.4521 84.0252 78.011 72.0243L78.0188 71.995V71.9657C77.8066 57.6198 83.256 44.2839 86.7511 30.525V30.5172V30.5094C88.6999 20.2764 92.0156 10.2635 93.9738 -0.000415566H93.466L93.4659 -0.000976562Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1086_49"
}, /*#__PURE__*/React.createElement("rect", {
  width: 165,
  height: 165,
  fill: "white"
})));

var SvgD2 = function SvgD2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d_2.4e92324f.svg";
export { ForwardRef as ReactComponent };